<div [formGroup]="parentFormGroup" [ngClass]="{ currency: frequence }" [class]="customClassesString">
  <mat-form-field
    class="input-field"
    appearance="outline"
    [floatLabel]="'always'"
    [ngClass]="{ 'relative-error-message': isRelativeErrorMessage }"
  >
    <input
      matInput
      autocomplete="off"
      maxlength="9"
      attr.aria-labelledby="{{ accessibilityLabel }}"
      #currencyInput
      [currencyMask]="mask"
      [id]="id"
      [name]="formName"
      [formControlName]="formName"
      [placeholder]="0"
      [required]="required"
      [errorStateMatcher]="errorStateMatcher"
      (keydown.enter)="updateFormValue(currencyInput.value)"
      (blur)="emit()"
      [ngClass]="{ alignRight: textAlign === 'right' }"
    />
    <span matTextSuffix *ngIf="shouldDisplayDollarSign && langue === 'fr'">&nbsp;$</span>
    <span matTextPrefix *ngIf="shouldDisplayDollarSign && langue === 'en'">$&nbsp;</span>
    <div matTextSuffix class="matSuffix" *ngIf="frequence">
      &nbsp;${{ frequence | translate }} <span class="sr-only" [innerText]="frequence + '.sr-only' | translate"></span>
    </div>
    <mat-error
      class="error-messages"
      id="erreur-{{ id }}"
      *ngIf="parentFormGroup.controls[this.formName].errors?.required"
    >
      <span class="sr-only">{{ 'erreur.general' | translate }}</span>
      {{ 'erreur.champ-obligatoire' | translate }}
    </mat-error>
    <mat-error class="error-messages" id="erreur-{{ id }}" *ngIf="parentFormGroup.controls[this.formName].errors?.min">
      <span class="sr-only">{{ 'erreur.general' | translate }}</span>
      {{
        minInputErrorMessage
          ? minInputErrorMessage
          : ('erreur.minimum-amount' | translate: { minInput: minInput | desjardinsCurrency })
      }}
    </mat-error>
    <mat-error
      class="error-messages"
      id="erreur-{{ id }}"
      *ngIf="
        parentFormGroup.controls[this.formName].errors && parentFormGroup.controls[this.formName].errors[customError]
      "
    >
      <span class="sr-only">{{ 'erreur.general' | translate }}</span>
      {{ customErrorMessage }}
    </mat-error>
    <mat-error
      id="erreur-{{ id }}"
      *ngIf="parentFormGroup.controls[this.formName].errors?.max"
      [innerHtml]="maxInputErrorMessage"
    >
    </mat-error>
  </mat-form-field>
</div>
